<template>
  <v-container fluid class="pa-0">
    <v-row dense align="stretch">
      <v-col
        v-for="product in products"
        :key="product.id || product.name"
        cols="12"
        sm="6"
        md="6"
        lg="4"
        class="d-flex px-4">
        <v-card
          outlined
          elevation="2"
          class="pb-6 card-product d-flex flex-column flex-grow-1 cursor-pointer"
          @click="openEdit(product)">
          <v-card-title class="py-3">
            <div class="d-flex align-center">
              <v-img
                :src="getImage(product)"
                max-width="60"
                max-height="60"
                contain
                class="mr-3 image-thumb"></v-img>

              <div class="d-flex flex-column">
                <div class="title-text">
                  {{ product.name }}
                </div>
              </div>
            </div>
          </v-card-title>

          <v-card-text class="pt-0 pb-0 flex-grow-1 card-body">
            <div class="mb-1">
              <span class="font-weight-bold">
                {{ $t('entities.categories.entity') }}:
              </span>
              <span>{{ getCategoryName(product.category_id) }}</span>
            </div>
            <div class="mb-1">
              <span class="font-weight-bold">
                {{ $t('entities.products.numberOfVariants') }}:
              </span>
              <span>{{ getVariantsCount(product.variants) }}</span>
            </div>

            <div class="mt-2">
              <div class="font-weight-bold mb-1">
                {{ $t('generalAttributes.description') }}:
              </div>
              <div class="description-text">
                {{ product.description || '—' }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ArenaProductsCardList',
  props: {
    products: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
  },
  methods: {
    getImage(product) {
      const placeholderUrl =
        'https://images.fineartamerica.com/images/artworkimages/mediumlarge/2/pit-bull-puppy-square-dog-photography.jpg'
      return product.image || placeholderUrl
    },
    getCategoryName(categoryId) {
      if (!categoryId || !this.categories.length) {
        return '—'
      }
      const match = this.categories.find((cat) => cat.id === categoryId)
      return match?.name || '—'
    },
    getVariantsCount(variants) {
      return Array.isArray(variants) ? variants.length : 0
    },
    openEdit(product) {
      this.$emit('product:upsert', product)
    },
  },
}
</script>

<style scoped>
.card-item {
  height: 100%;
}

.card-body {
  flex-grow: 1;
}

.image-thumb {
  border-radius: 4px;
}

.title-text {
  word-break: break-word;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
